import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {staticPagesEdit_template} from "../components/templates/staticPagesEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';

let contentEditor;

export class static_page_edit extends vnModule_knockoutJS{
    protected staticPagesEdit : staticPagesEdit_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.staticPagesEdit = new staticPagesEdit_template('static_page_edit_template', this.viewModel, this)
        return [this.staticPagesEdit.build()]
    }

    protected getModuleName(): string {
        return "static_page_edit";
    }

    public fillPage() {

        this.getStaticPageDataForEdit()

    }

    public getIdBrand(): number {
        return this.getVnAppZone().app.params.idBrand;
    }

    public viewOnWebsite(permalink: string) {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        let url = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if ( url.length == 3 ) { // Not on live

            if ( url[0] != "emakicms") { // Either on qa, staging or ads
                urlBegin += url[0]+".";
            } else {
                isLocal = true;
            }
        }

        for (let i=0; i< userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {

                window.open(urlBegin + userBrands[i].domain.replace("www.", "") + ( isLocal ? ( "." +url[2] ) : "" ) + permalink, "_blank")
                break;
            }
        }
    }

    private getStaticPageDataForEdit() {
        this.loadingIn(this.staticPagesEdit.builtTemplate);


        if (this.getVnAppZone().app.params.hasOwnProperty('id')){
            this.staticPagesEdit.setContextApp("Edit Static Page");
            this.staticPagesEdit.isEditionMode(true);
        }else{
            this.staticPagesEdit.setContextApp("Add New Static Page");
            this.staticPagesEdit.isEditionMode(false);
        }

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/staticpage/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetStaticPageDataForEdit;
        this.XHRHdl.execute();

    }

    private onGetStaticPageDataForEdit(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let staticpage = responseParsed.data;
                obj.setStaticPageData(staticpage);
                let versions = responseParsed.versions || [];
                obj.staticPagesEdit.setVersions(versions);

            });

            obj.loadingOut(obj.staticPagesEdit.builtTemplate);
        }
    }

    protected setStaticPageData(staticPage) {

        this.initializeCkEditor();
        this.staticPagesEdit.setId(staticPage.id);
        this.staticPagesEdit.setName(staticPage.name);
        this.staticPagesEdit.setDescription(staticPage.description);
        this.staticPagesEdit.setPermalink(staticPage.permalink);
        this.staticPagesEdit.setStyle(staticPage.style);
        this.staticPagesEdit.setContentText(staticPage.content);
        this.staticPagesEdit.setIndexed(staticPage.indexed);
        this.staticPagesEdit.setHasNewsletterSignup(staticPage.hasNewsletterSignup);
        this.staticPagesEdit.setHasSentinelEvents(staticPage.hasSentinelEvents);
        this.staticPagesEdit.setCategory(staticPage.category || "");
        this.staticPagesEdit.setDateCreated(staticPage.dateCreated);
        this.staticPagesEdit.setDateUpdated(staticPage.dateUpdated);

    }

    protected initializeCkEditor() {
        if (!CKEDITOR.stylesSet.registered.my_styles) {
            CKEDITOR.stylesSet.add('my_styles', [
                // Block-level styles.
                /*{ name: 'Related: One link', element: 'h2', styles: { color: 'Blue' } },
                { name: 'Next - One link',  element: 'h3', styles: { color: 'Red' } },*/
                {name: 'Heading 1', element: 'h1'},
                {name: 'Heading 2', element: 'h2'},
                {name: 'Heading 3', element: 'h3'},
                {name: 'Preformatted', element: 'pre'},
                // Inline styles.
                {name: 'Related: One link', element: 'span', attributes: {'class': 'related-single'}},
                {name: 'Next - One link', element: 'span', attributes: {'class': 'next-single'}},
                {name: 'Affiliate - One link', element: 'span', attributes: {'class': 'affiliate-single'}},
                {name: 'Spoiler Alert', element: 'span', attributes: {'class': 'article-alert'}},
            ]);
        }

        if (!CKEDITOR.plugins.registered.editMenu) {
            CKEDITOR.plugins.add("editMenu", {
                init: function (editor) {
                    editor.ui.addRichCombo("EditMenu", {
                        label: "Edit",
                        title: "Edit",
                        toolbar: "clipboard,0",
                        panel: {
                            css: [CKEDITOR.skin.getPath("editor")].concat(editor.config.contentsCss),
                            multiSelect: false,
                        },
    
                        init: function () {
                            this.add("Cut", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -312px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Cut", "Cut");
                            this.add("Copy", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -264px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Copy", "Copy");
                            this.add("Paste", "<span style=\"display:inline-block;width:16px;height:16px;background-image:url('/node_modules/ckeditor4/plugins/icons.png?t=M2GA');background-position:0 -360px;background-size:auto;background-repeat:no-repeat;vertical-align:middle;margin-right:8px;\"></span>Paste", "Paste");
                        },
    
                        onClick: function (value) {
                            try {
                                editor.focus();
                            } catch (_) {}
    
                            switch (value) {
                                case "Cut":
                                    editor.execCommand("cut");
                                    break;
                                case "Copy":
                                    editor.execCommand("copy");
                                    break;
                                case "Paste":
                                    editor.execCommand("paste");
                                    break;
                            }
                        },
                    });
                },
            });
        }


        CKEDITOR.on('dialogDefinition', function (ev) {
            var dialogName = ev.data.name;
            var dialogDefinition = ev.data.definition;

            //remove features from table dialog
            if (dialogName == 'table') {

                // Get the advanced tab reference
                var infoTab2 = dialogDefinition.getContents('advanced');

                //Set the default
                // Remove the 'Advanced' tab completely
                dialogDefinition.removeContents('advanced');

                // Get the properties tab reference
                var infoTab = dialogDefinition.getContents('info');

                // Remove unnecessary bits from this tab
                /// infoTab.remove('txtBorder');
                infoTab.remove('cmbAlign');
                infoTab.remove('txtWidth');
                infoTab.remove('txtHeight');
                // infoTab.remove('txtCellSpace');
                //infoTab.remove('txtCellPad');
                infoTab.remove('txtCaption');
                infoTab.remove('txtSummary');
            }

            if (dialogName == 'link') {

                /* Getting the contents of the Target tab */

                var targetTab = dialogDefinition.getContents('target');
                var informationTab = dialogDefinition.getContents('info');
                var advancedTab = dialogDefinition.getContents('advanced');

                //remove the browse server button
                informationTab.remove('browse')

                //moving the target dropdown to the main tab
                var targetField = targetTab.get('linkTargetType');

                targetTab.remove('linkTargetType');
                informationTab.add(targetField);

            }
        });

        let _myThis = this;
        CKEDITOR.on('instanceReady', function (evt) {
            var editor = evt.editor;

            editor.on('afterSetData', function (e) {
            });

            editor.on('focus', function (e) {

            });

        });


        this.initCkEditor('contenttext');
        contentEditor = CKEDITOR.instances.contenttext;
        this.addLinkToolCommand(contentEditor);
    }

    protected initCkEditor(idElement) {

        CKEDITOR.config.skin = "emakiCustomComprehensive";
        this.allowDialogTagsInCkEditor();
        
        CKEDITOR.replace(idElement, {
            height: '500px',
            toolbar: 'MA',
            fillEmptyBlocks: false,
            allowedContent: true,
            extraAllowedContent: 'img(*){*}[*];div(*){*}[*];dialog(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a(*)',
            disallowedContent: 'p',
            removePlugins: 'elementspath,contextmenu,liststyle,tabletools,tableselection,image,forms',
            stylesSet: 'my_styles',
            format_tags: "p;h1;h2;h3",
            format_p: {
                element: 'p'
            }
        });

        //'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'
        //'Outdent','Indent'

        CKEDITOR.config.toolbar_MA = [['Source', '-', 'EditMenu', '-', 'Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-', 'Table', 'HorizontalRule', 'SpecialChar', 'ImgBtn', 'Styles','-','Bold', 'Italic', 'Strike', 'NumberedList', 'BulletedList', '-', 'Blockquote'],['Maximize']];

        CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;

        CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), '/css/cke_style.css?v=2.5'];

        //CKEDITOR.config.disallowedContent = 'p';

        
        //CKEDITOR.config.skin ="kama";
        //CKEDITOR.config.skin ="moono";
        //CKEDITOR.config.skin ="moono-lisa";

        CKEDITOR.config.extraPlugins = "wordcount,notification,editMenu";
        //CKEDITOR.config.extraPlugins ="justify";
        //CKEDITOR.config.extraPlugins ="colorbutton";
        CKEDITOR.config.forcePasteAsPlainText = true;
        contentEditor = CKEDITOR.instances.contenttext;

        CKEDITOR.config.wordcount = {
            // Whether or not you want to show the Paragraphs Count
            showParagraphs: false,

            // Whether or not you want to show the Word Count
            showWordCount: true,

            // Whether or not you want to show the Char Count
            showCharCount: true
        }
        CKEDITOR.config.allowedContent = true;


    }

    private allowDialogTagsInCkEditor() {
        CKEDITOR.dtd.dialog = CKEDITOR.tools.extend({}, CKEDITOR.dtd.div);

        CKEDITOR.dtd.body.dialog = 1;
        CKEDITOR.dtd.div.dialog = 1;
        CKEDITOR.dtd.div.span = 1;

        CKEDITOR.dtd.a = CKEDITOR.dtd.a || {};
        CKEDITOR.dtd.a.div = 1;
        CKEDITOR.dtd.a.dialog = 1;

        if (CKEDITOR.dtd.$block) {
            CKEDITOR.dtd.$block.dialog = 1;
        }

        if (CKEDITOR.dtd.$blockLimit) {
            CKEDITOR.dtd.$blockLimit.dialog = 1;
        }

        if (CKEDITOR.dtd.$empty) {
            delete CKEDITOR.dtd.$empty.dialog;
        }

        if (CKEDITOR.dtd.$removeEmpty) {
            delete CKEDITOR.dtd.$removeEmpty.dialog;
            delete CKEDITOR.dtd.$removeEmpty.span;
        }
    }



    protected addLinkToolCommand(editor) {

        function showLinkTool(obj) {

            return {
                exec: function (editor) {
                    obj.showLinkTool();
                }
            };

        }

        editor.addCommand("linkToolCommand", showLinkTool(this));

        editor.ui.addButton('LinkBtn', { // add new button and bind our command
            label: "Link Tool",
            command: 'linkToolCommand',
            toolbar: 'insert',
        });

    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public onClickCancelEdit(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/config/static-pages/" )
        //this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Edit static page canceled !");
    }


    protected save(){
        this.loadingIn(this.staticPagesEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/staticpage/save/";
        let formReq_params: Array<Array<string>> = [];

        this.viewModel.static_page_edit_template.content(contentEditor.getData());

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));


        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/brand/' + idBrand + "/config/static-pages/");

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Static page saved !");
                        //obj.getVnAppZone().showNotificationToModule();
                    }

                });
                obj.loadingOut(obj.staticPagesEdit.builtTemplate);



            }
        });
        XHRHdl.execute();
    }

    public downloadVersion(version) {
        let url : string = 'https://'+window.location.hostname+'/api/brand/' + this.getVnAppZone().app.params.idBrand + '/staticpage/version/' + version.id + '/download/';
        
        // Create a temporary link to trigger download
        let link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

}



// WEBPACK FOOTER //
// ./js/modules/static_page_edit.ts